import React from "react";
import ContactSection from "./SECTIONS/CONTACT";

import "./index.css";

const ContactPage = () => {
  return (
    <>
      <br />
      <ContactSection className="contact-section" />
    </>
  );
};

export default ContactPage;
